import ObjectManager from './ObjectManager.vue'
export default ObjectManager
